import React from 'react'
import clsx from 'clsx'
import { FormControlLabel, Checkbox } from '@material-ui/core'
import useStyles from './FormFieldsStyle'

export default function DoubleCheckbox({ field }) {
  const classes = useStyles()

  return (
    <div
      className={clsx(
        classes.container,
        field.withMargin && classes.withMargin
      )}
    >
      {field.checkboxes.map((checkbox, i) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={checkbox.checked}
              onChange={checkbox.onChange}
              name={checkbox.label}
              className={classes.checkbox}
            />
          }
          label={checkbox.label}
          className={i === 0 && classes.withRightMargin}
        />
      ))}
    </div>
  )
}
